import { Empty, useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import { Layout } from 'antd';
import React, { createContext, useState } from 'react';
import styles from './index.module.scss';
import DragResize from '@/components/DragResize';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import RightContent from './RightContent';
import AreaTree from './AreaTree';
import { isNil } from 'lodash-es';
import noEnergyUnitIcon from './imgs/icon-disconnectedWithDevice.png';

const { Content, Sider } = Layout;

export const EnergyStaticNoProductContext = createContext<{
  areaId?: number;
  energyUnitId?: number;
  setAreaId?: (areaId?: number) => void;
  setEnergyUnitId?: (energyUnitId?: number) => void;
}>({});

const EnergyStaticNoProduct = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [openSider, setOpenSider] = useState(true);
  const [areaId, setAreaId] = useState<number>();
  const [energyUnitId, setEnergyUnitId] = useState<number>();

  // 初始值
  const [siderWidth, setSiderWidth] = useState(260);
  // 拖拽状态
  const [dragStatus, setDragStatus] = useState(false);

  const dragChange = (width: number) => {
    if (openSider) {
      setSiderWidth(width);
    }
  };

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} hasPadding={false}>
      <EnergyStaticNoProductContext.Provider value={{ areaId, setAreaId, energyUnitId, setEnergyUnitId }}>
        <Layout className={styles.layout}>
          <Sider
            className={styles.siderDemo}
            width={openSider ? siderWidth : 0}
            style={{ transition: dragStatus ? 'none' : 'all 0.2s' }}
          >
            <DragResize init={260} dragChange={dragChange} dragStatus={setDragStatus} />
            <AreaTree />
          </Sider>
          <Content className={styles.content} style={{ marginLeft: openSider ? 10 : 0 }}>
            <div className="toggleBtn" style={{ left: openSider ? -30 : 0 }} onClick={() => setOpenSider(!openSider)}>
              {openSider ? <LeftOutlined /> : <RightOutlined />}
            </div>
            <div style={{ height: 'calc(100vh - 128px)', overflowY: 'auto' }}>
              {isNil(energyUnitId) ? (
                <Empty style={{ paddingTop: 200 }} image={noEnergyUnitIcon} description="未绑定用能单元" />
              ) : (
                <RightContent />
              )}
            </div>
          </Content>
        </Layout>
      </EnergyStaticNoProductContext.Provider>
    </Wrapper>
  );
};

export default EnergyStaticNoProduct;
